<template>
    <div class="con">
        <div class="one">
            <div class="main">
                <div class="left">
                   <p class="t1">GET IN TOUCH</p>
                    <div class="item">
                      <p>{{$t('foot').column0[0]}}</p>
                        <p>+0574-28820588</p>
                    </div>
                    <div class="item">
                        <p>{{$t('foot').column0[1]}}</p>
                        <p>+18668284666</p>
                    </div>
                    <div class="item">
                        <p>{{$t('foot').column0[2]}}</p>
                        <p>JRB18668284666</p>
                    </div>
                </div>
                <div class="center">
                    <p class="t1">POPULAR NEWS</p>
                    <div class="item" v-for="(item,index) in list" :key="index"  @click="gotoInfo(item.id)">
                      <div class="l">
                          <img :src="`http://runbo.sansg.com/${item.picurl}`" alt="">
                      </div>
                        <div class="r">
                             <p>{{item.title}}</p>
                            <p>{{item.posttime}}</p>
                        </div>
                    </div>
                </div>
                <div class="r">
                    <p class="t1">POPULAR NEWS</p>
                    <a href="./about.html">{{$t('foot').column1[0]}}</a>
                    <a href="./job.html">{{$t('foot').column1[1]}}</a>
                    <a href="./human.html">{{$t('foot').column1[2]}}</a>
                    <a href="./news.html">{{$t('foot').column1[3]}}</a>
                    <a href="./pro.html">{{$t('foot').column1[4]}}</a>
                    <a href="./contact.html">{{$t('foot').column1[5]}}</a>
                    <div class="input">
                        <input type="text" :placeholder="$t('foot').column1[6]"  v-model="form.content">
                        <div class="btn" @click="send">
                            <img src="../assets/rj/fs.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <p class="t1">POPULAR NEWS</p>
                    <div class="aPic">
                        <div class="item">
                            <div >
                                <img src="../assets/rj/code1.png" alt="">
                            </div>
                            <p>{{$t('foot').column2[0]}}</p>
                        </div>
                        <div class="item">
                            <div >
                                <img src="../assets/rj/code2.png" alt="">
                            </div>
                            <p>{{$t('foot').column2[1]}}</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="two">
            <div class="main">
                <p>
                    Copyright©2020 宁波润博智能科技有限公司 All Rights Reserved
                    <a href="http://beian.miit.gov.cn/" target="_blank">
                        版权所有 浙ICP备2021028863号-1
                    </a>
                </p>
                <a href="https://www.sansg.com/" target="_blank">
                    POWERED BY 三盛网络
                </a>

            </div>
        </div>
    </div>
</template>

<script>
    import {getFooter} from '../util/lang'
    import qs from "qs";
    export default {
        name: "foot",
        data(){
            return{
                form:{
                    content:''
                },
                list:[
                    // {
                    //     img:require('../assets/rj/fn.png'),
                    //     title:' [新闻] 软玻璃的特点...',
                    //     time:'2020.04.15'
                    // },
                    // {
                    //     img:require('../assets/rj/fn2.png'),
                    //     title:' [新闻] 软玻璃的特点...',
                    //     time:'2020.04.15'
                    // }
                ]
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.getNews()
            })
        },
        methods:{
            send(){
                if(this.form.content==''){
                    this.$notify({
                        title: "提示",
                        message: "请填写您的联系方式",
                        offset: 100
                    });
                }else{
                    this.$nextTick(() => {
                        const url = "/common/Form.php";
                        this.$axios.post(url, qs.stringify(this.form)).then(res => {
                            if (res.status === 200) {
                                this.$notify({
                                    title: "Success",
                                    message: "Submitted Successfully",
                                    offset: 100
                                });
                                this.form={
                                    content:''
                                }
                            } else {
                                this.$notify({
                                    title: "失败",
                                    message: "提交失败",
                                    offset: 100
                                });
                            }
                        });
                    });
                }

            },
            gotoInfo(id){
                const  link=`./newsInfo.html?id=${id}`
                window.open(link,'_self')
            },
            getNews(){
                const url = `${getFooter()}`
                this.$axios.get(url).then(res => {
                    this.list=res.data
                 // console.log(res.data)
                })
            },
            goto(n,i){
                console.log(n,i)
                if(n===0 && i===0){
                    const link='/about.html'
                    window.open(link,'_self')
                }else if(n===0 && i!==0){
                    const link=`/about.html?index=${i-1}`
                    window.open(link,'_self')
                }else if(n===1 && i===0){
                    const link='/pro.html'
                    window.open(link,'_self')
                }else if(n===1 && i!==0){
                    const link=`/pro.html?id=${i-1}`
                    window.open(link,'_self')
                }else if(n===2 && i===0){
                    const link='/news.html'
                    window.open(link,'_self')
                }else if(n===2 && i!==0){
                    const link=`/news.html?index=${i-1}`
                    window.open(link,'_self')
                }else if(n===3 && i===0){
                    const link='/job.html'
                    window.open(link,'_self')
                }else if(n===3 && i!==0){
                    const link=`/job.html?index=${i-1}`
                    window.open(link,'_self')
                }else if(n===4 && i===0){
                    const link='/tech.html'
                    window.open(link,'_self')
                }else if(n===4 && i!==0){
                    const link=`/tech.html?index=${i-1}`
                    window.open(link,'_self')
                } else if(n===5 && i===0){
                    const link='/contact.html'
                    window.open(link,'_self')
                } else {
                    const link=`/contact.html?index=${i-1}`
                    window.open(link,'_self')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        .one{
            width:100%;
            position: relative;
            background: url("../assets/rj/footBg.png") no-repeat;
            background-size: cover;
            .main{
                width:80%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 0 auto;
                padding: 60px 0;
                .left{
                    .t1{
                        font-family: "Geometric";
                        color:white;
                        margin-bottom: 40px;
                    }
                    .item{
                        margin-bottom: 20px;
                        p:nth-child(1){
                            color:rgba(255,255,255,.3);
                            font-family: "SourceHanSansSC-Regular";
                            font-size: 14px;
                        }
                        p:nth-child(2){
                            color:white;
                            font-family: "Geometric";
                            margin-top: 10px;
                            font-size: 14px;
                        }
                    }
                }
                .center{
                    width:20%;
                    .t1{
                        font-family: "Geometric";
                        color:white;
                        margin-bottom: 40px;
                    }
                    .item{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        cursor: pointer;
                        align-items: center;
                        .l{
                            width:40%;
                            overflow: hidden;
                            img{
                                width:100%;
                                display: block;
                                object-fit: cover;
                                transition: all 600ms;
                            }
                        }
                        .r{
                            width:55%;
                            p:nth-child(1){
                                color:rgba(255,255,255,.3);
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                width:100%;
                                height:20px;
                                transition: all 600ms;
                                font-size: 14px;
                            }
                            p:nth-child(2){
                                color:white;
                                font-family: "Geometric";
                                margin-top: 15px;
                                font-size: 14px;
                            }
                        }
                        &:hover{
                            .l{
                                img{
                                    transform: scale(1.05);
                                }
                            }
                            .r{
                                p:nth-child(1){
                                    color:#EA5404;
                                }
                            }
                        }
                    }
                }
                .r{
                   width:20%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .t1{
                        font-family: "Geometric";
                        font-size: 21px;
                        color:white;
                        margin-bottom: 20px;
                        opacity: 0;
                    }
                    a{
                        width:50%;
                        display: inline-block;
                        color:white;
                        font-size: 16px;
                        font-family: "AdobeHeitiStd-Regular";
                        transition: all 600ms;
                        &:hover{
                            color:#EA5404;
                        }
                    }
                    a:nth-of-type(even){
                        text-align: right;
                    }
                    .input{
                        width:100%;
                        position: relative;
                        margin-top: 30px;
                        height:46px;
                        background:rgba(255,255,255,.8);
                        input{
                            width:100%;
                            height:100%;
                            line-height: 46px;
                            font-family: "SOURCEHANSANSCN-LIGHT";
                            color:white;
                            background-color: transparent;
                            border: none;
                            text-indent: 10px;
                            font-size: 14px;
                        }
                        .btn{
                            width:50px;
                            height:100%;
                            right:0;
                            background:rgba(234,84,4,1);
                            position: absolute;
                            top:0;
                            cursor: pointer;
                            text-align: center;
                            img{
                                margin-top: 10px;
                                transition: all 600ms;
                            }
                            &:hover{
                                img{
                                    transform: rotateY(360deg);
                                }
                            }

                        }
                        input:focus{
                            outline: none;
                        }
                    }
                }
                .codes{
                    .t1{
                        font-family: "Geometric";
                        font-size: 21px;
                        color:white;
                        margin-bottom: 45px;
                        opacity: 0;
                    }
                    .aPic{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        .item{
                            width: 152px;
                            height: 152px;
                            text-align: center;
                            margin-bottom: 32px;
                            margin-right: 10px;
                            img {
                              width: 100%;
                              height: 100%;
                            }
                            p{
                                color:#DDDDDD;
                                font-family: "SOURCEHANSANSCN-LIGHT";
                                margin-top: 5px;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
        .two{
            width:100%;
            background-color: #373433;
            .main{
                width:80%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin: 0 auto;
                padding: 25px 0;
                a,p{
                    color:rgba(255,255,255,.5);
                    font-family: "SOURCEHANSANSCN-LIGHT";
                    text-transform: uppercase;
                    font-size: 14px;
                }
                p{
                    i{
                        font-size: 28px;
                        margin: 0 5px;
                        cursor: pointer;
                        transition: all 600ms;
                        &:hover{
                            color:#EA5404;
                        }
                    }
                }
                a{
                    transition: all 600ms;
                    &:hover{
                        color:#EA5404;
                    }
                }
            }
        }
        @media screen and (max-width: 1440px) {
            .one{
                .main{
                    width:90%;
                }
            }
            .two{
                .main{
                    width:90%;
                }
            }

        }
        @media screen and (max-width: 1000px){
           .one{
               .main{
                   padding: 30px 0;
                   .center,.r{
                       display: none;
                   }
                   .codes{
                       .t1{
                           display: none;
                       }
                       .aPic{
                           flex-direction: column;
                           .item{
                               img{
                                   width: 100%;
                               }
                           }
                       }
                   }
               }
           }
            .two{
                .main{
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 28px;
                    p,a{
                        text-align: center;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
